<!-- eslint-disable max-len -->
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18 18"
    class="label-icon"
  ><path
    d="M11.12 11.94H6.86l-.89 2.56H3.98l4.16-11h1.71l4.16 11h-1.99l-.9-2.56ZM7.4 10.4h3.19L9 5.84 7.41 10.4Z"
  /><path
    d="M16 18H2c-1.1 0-2-.9-2-2V2C0 .9.9 0 2 0h14c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2ZM2 2v14h14V2H2Z"
  /></svg>
</template>

<script>
export default {
  name: 'LabelIcon',
};
</script>

<style scoped lang="scss">
.label-icon > * {
  fill: var(--feature-color, main.$npGray);
}
.label-icon.disabled > * {
  fill: darkgrey;
}
.label-icon.selected > * {
  fill: #fff;
}
</style>
